// removed by extract-text-webpack-plugin
module.exports = {"sidebarContainer":"src-components-Sidebar----Sidebar-module---sidebarContainer---23pLk","datePickerContainer":"src-components-Sidebar----Sidebar-module---datePickerContainer---3LcQI"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Sidebar/Sidebar.module.css
// module id = 570
// module chunks = 67997519577666